"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowPerformerGrid = exports.calculateColumnCount = exports.calculateMissingRows = exports.emitSearchReceivedEvent = exports.getSearchQueryDataForTracking = void 0;
exports.getWidthAndColumns = getWidthAndColumns;
exports.propsToDataOptions = propsToDataOptions;
var RequestInterfaces_1 = require("icf-search-client-data/lib/RequestInterfaces");
var SearchFilters_1 = require("icf-search-client-data/lib/SearchFilters");
var RecommenderSession_1 = require("icf-search-client-shared/lib/services/RecommenderSession");
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var SearchFieldContainer_1 = require("./SearchFieldContainer");
var SearchResultsSectionThumbnails_1 = require("./SearchResultsSectionThumbnails");
var maximumDataRequestSize = 48;
function getStartIndexForPage(pageIndex, resultsPerPage) {
    return pageIndex * resultsPerPage;
}
function getDataRangeProps(pageIndex, resultsPerPage, isSearchFreeAccountGridXmentEnabled) {
    var startIndex = getStartIndexForPage(pageIndex, resultsPerPage);
    if (isSearchFreeAccountGridXmentEnabled) {
        if (pageIndex === 0) {
            return {
                dataRequestPageSize: Math.min(resultsPerPage, maximumDataRequestSize),
                itemRange: { start: startIndex, end: startIndex + resultsPerPage },
            };
        }
        else {
            return {
                dataRequestPageSize: Math.min(resultsPerPage, maximumDataRequestSize),
                itemRange: {
                    start: startIndex - 1,
                    end: startIndex + resultsPerPage - 1,
                },
            };
        }
    }
    else {
        return {
            dataRequestPageSize: Math.min(resultsPerPage, maximumDataRequestSize),
            itemRange: { start: startIndex, end: startIndex + resultsPerPage },
        };
    }
}
function getFallbackDataProps(resultsPerPage, isNotFound, genderSetting, dataOptions, isSearchFreeAccountGridXmentEnabled) {
    var genderFilter = getGenderFilterFromOptions(dataOptions);
    var fallbackFilters = {
        advanced: isNotFound
            ? []
            : [
                {
                    name: "online",
                    title: "online",
                    options: [
                        {
                            label: "online",
                            value: "true",
                            isChecked: true,
                        },
                    ],
                },
            ],
        gender: genderFilter ? genderFilter.gender : getGenderFilterFromSetting(genderSetting),
    };
    return __assign(__assign({}, getDataRangeProps(0, resultsPerPage, isSearchFreeAccountGridXmentEnabled)), { queryOptions: {
            type: "browse",
            isNotFound: isNotFound,
            filters: fallbackFilters,
            genderSetting: genderSetting,
        }, shuffled: !isNotFound && (0, SearchFilters_1.getAdvancedFilterArray)(dataOptions.filters).length === 0, genderSetting: genderSetting });
}
function getSearchDataProps(resultsPerPage, queryOptions, isSearchFreeAccountGridXmentEnabled) {
    if (queryOptions.type === "browse" && queryOptions.isNotFound) {
        return __assign(__assign({}, getFallbackDataProps(resultsPerPage, true, queryOptions.genderSetting, queryOptions, isSearchFreeAccountGridXmentEnabled)), { 
            // For 404, we consider it a fallback immediately, ignoring the result count being above 0
            asDirectFallback: true });
    }
    return { queryOptions: queryOptions };
}
function getGenderFilterFromOptions(queryOptions) {
    return queryOptions.type !== "favorites"
        ? queryOptions.filters
            ? { gender: queryOptions.filters.gender }
            : undefined
        : undefined;
}
function getWidthAndColumns(size) {
    var optimalWidth;
    var availableColumnCounts;
    switch (size) {
        case SearchResultsSectionThumbnails_1.ThumbnailSize.small:
            optimalWidth = 240;
            availableColumnCounts = [2, 3, 4, 6, 8, 12];
            break;
        case SearchResultsSectionThumbnails_1.ThumbnailSize.medium:
        default:
            optimalWidth = 320;
            availableColumnCounts = [2, 3, 4, 6, 8, 12];
            break;
        case SearchResultsSectionThumbnails_1.ThumbnailSize.large:
            optimalWidth = 480;
            availableColumnCounts = [2, 3, 4, 6, 8, 12];
            break;
    }
    return { optimalWidth: optimalWidth, availableColumnCounts: availableColumnCounts };
}
function propsToDataOptions(resultsProps, isSearchFreeAccountGridXmentEnabled) {
    if (isSearchFreeAccountGridXmentEnabled === void 0) { isSearchFreeAccountGridXmentEnabled = false; }
    var pageNumber = resultsProps.pageNumber, resultsPerPage = resultsProps.resultsPerPage, queryOptions = resultsProps.queryOptions, useLoadMore = resultsProps.useLoadMore, itemCount = resultsProps.itemCount;
    var dataRangeProps = useLoadMore
        ? getDataRangeProps(0, itemCount, isSearchFreeAccountGridXmentEnabled)
        : getDataRangeProps(Math.max(pageNumber - 1, 0), resultsPerPage, isSearchFreeAccountGridXmentEnabled);
    return __assign(__assign(__assign({}, dataRangeProps), getSearchDataProps(resultsPerPage, queryOptions, isSearchFreeAccountGridXmentEnabled)), { fallbackData: queryOptions.type === "browse" && queryOptions.isNotFound
            ? undefined
            : getFallbackDataProps(resultsPerPage, false, getGenderSetting(), queryOptions, isSearchFreeAccountGridXmentEnabled), cacheTtlMs: 20000, failureDelayMs: 10000, genderSetting: getGenderSetting() });
}
// For favorites fallback, we need to define default genders
// that match what we set in SCP. We don't want to set a
// gender filter on the favorites queryOptions, as it was
// decided that you should be able to see all your favorites
// regardless of what gender tab you are on. But we do want
// to honor the gender selection for fallback results.
var AllFemaleGenders = "f,ff,mf,tm2f,g";
var AllMaleGenders = "m,mm,tf2m,g";
// gender setting is used to determine gender sort order
function getGenderSetting() {
    return "none";
}
function getGenderFilterFromSetting(genderSetting) {
    var value = ({
        f: AllFemaleGenders,
        m: AllMaleGenders,
    }[genderSetting] || "");
    return {
        label: "gender",
        value: value,
        filters: [
            {
                name: "gender",
                value: value,
                isBoosted: false,
            },
        ],
    };
}
var getSearchQueryDataForTracking = function (params) {
    var queryOptions = params.queryOptions, siteId = params.siteId, isUserLoggedIn = params.isUserLoggedIn, from = params.from, size = params.size, index = params.index;
    var filters = __assign({}, (0, SearchFilters_1.getSplitFiltersWithExcludedFiltersForTracking)({
        filters: queryOptions.filters,
        excludedFilters: queryOptions.excludedFilters,
        notExactBoostedFilters: queryOptions.notExactBoostedFilters,
    }));
    if (queryOptions.type === "category" && queryOptions.category) {
        filters.filters["category"] = queryOptions.category;
    }
    return JSON.stringify(__assign(__assign({}, filters), { language: queryOptions.language, country: queryOptions.country, queryType: queryOptions.type, query: queryOptions.type === "keyword" ? queryOptions.keyword.substr(0, SearchFieldContainer_1.maxQueryLength) : "none", siteId: siteId, from: from, size: size, index: index, isUserLoggedIn: isUserLoggedIn }));
};
exports.getSearchQueryDataForTracking = getSearchQueryDataForTracking;
var searchResultsReceived = "searchResultsReceivedV2";
var searchResultsReceivedType = "icfImpression";
var emitSearchReceivedEvent = function (emitTrackingEvent, eventPublisher, queryOptions, siteId, isUserAuthenticated) {
    return function (response) {
        if (response.results.length === 0) {
            return;
        }
        // Add response data
        var metaData = "totalPerformers=" + response.totalItems;
        // add recommender info if it is there
        if (!isUserAuthenticated) {
            var loggedOutRec = (0, RecommenderSession_1.getRecommenderSession)().experimentName;
            if (loggedOutRec) {
                metaData += "&loggedoutrec=" + loggedOutRec;
                metaData += "&variation=" + loggedOutRec; // TODO: Make sure things work for loggedinrec
            }
        }
        metaData += "&performerData=";
        // WTF wasn't this typed?
        var performerData = [];
        response.results.forEach(function (performer, index) {
            if (performer.hasDetails) {
                performerData.push({
                    performerId: performer.id,
                    rank: response.pageIndex * response.pageSize + index,
                    isNew: !!performer.new,
                });
            }
        });
        metaData += JSON.stringify(performerData);
        // Add query data
        metaData +=
            "&searchQueryData=" +
                (0, exports.getSearchQueryDataForTracking)({
                    queryOptions: queryOptions,
                    siteId: siteId,
                    isUserLoggedIn: isUserAuthenticated,
                    from: response.pageIndex * response.pageSize,
                    size: response.pageSize,
                    index: response.index,
                });
        emitTrackingEvent(searchResultsReceivedType, searchResultsReceived, metaData);
        (0, RecommenderSession_1.sendRecommenderSessionEvent)("gridViewed");
    };
};
exports.emitSearchReceivedEvent = emitSearchReceivedEvent;
var calculateMissingRows = function (resultsPerPage, columnCount, firstGridDataSource) {
    // Number of rows the page should have
    var rowCount = resultsPerPage / columnCount;
    // Number of performers from the dataSource
    var itemCount = firstGridDataSource.itemCount.value;
    // Number of rows that the items fill
    var numRows = Math.ceil(itemCount / columnCount);
    // Number of missing rows
    return rowCount - numRows;
};
exports.calculateMissingRows = calculateMissingRows;
var calculateColumnCount = function (thumbnailSize) {
    var _a = getWidthAndColumns(thumbnailSize), optimalWidth = _a.optimalWidth, availableColumnCounts = _a.availableColumnCounts;
    return (0, Utilities_1.getClosestNumber)(window.innerWidth / optimalWidth, availableColumnCounts);
};
exports.calculateColumnCount = calculateColumnCount;
/**
 * Helper method that determines if any performers & results should be shown depending on if specific error codes were
 * received from Search.WS
 */
var shouldShowPerformerGrid = function (errors) {
    if (errors) {
        var errorCodes = errors
            .filter(function (entry) { return !!entry; })
            .flatMap(function (error) {
            return error.code;
        });
        return !errorCodes.includes(RequestInterfaces_1.bannedQueryErrorCode);
    }
    return true;
};
exports.shouldShowPerformerGrid = shouldShowPerformerGrid;
//# sourceMappingURL=SearchResultsGridHelpers.js.map